export const RecordingProcessorChannel = "recording-to-client";
